<template>
  <div>
    <div class="login_bg">
      <div class="mobile_top">
        <span @click.prevent="onTout()">欢迎来到智污邦环保服务平台 </span>
        <span class="ml-30" @click.prevent="onSet()">帮助中心</span>
        <span class="ml-30" @click.prevent="onTout()">返回首页</span>
      </div>
      <div class="mobile_middle">
        <div class="moblie_conent">
          <div class="moblie_logo" @click.prevent="onTout()">
            <img src="../assets/images/logo.jpg" alt="" />
          </div>
          <div class="moblie_bater">
            <h4>用户注册</h4>
            <div class="mt-10">
              <el-form
                class="info_form"
                :rules="rules"
                :model="ruleForm"
                ref="ruleForm"
                label-width="80px"
              >
                <el-form-item class="mobile" prop="phone" style="width: 100%">
                  <img class="icon" src="../assets/images/mobile.png" alt="" />
                  <el-input
                    class="myClass"
                    placeholder="请输入手机号码"
                    maxlength="11"
                    v-model="ruleForm.mobile"
                    @blur="onInputBlur"
                  ></el-input>
                </el-form-item>
                <el-form-item class="phone" prop="type" style="width: 100%">
                  <img class="icon" src="../assets/images/entser.png" alt="" />
                  <el-select
                    v-model="ruleForm.type"
                    placeholder="请选择类型"
                    style="width: 100%"
                  >
                    <el-option label="个人" value="1"></el-option>
                    <el-option label="专家" value="2"></el-option>
                    <el-option label="企业" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item class="phone" prop="profession" style="width: 100%">
                  <img class="icon" src="../assets/images/ties.png" alt="" />

                  <el-select
                    v-model="ruleForm.profession"
                    placeholder="请选择所属行业"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item,index) in categoryList" 
                      :key="index"
                      :label="item.name"
                      :value="item.id"></el-option>
                  </el-select> 
                </el-form-item> -->
                 <el-form-item class="phone" prop="name" style="width: 100%">
                  <img class="icons" src="../assets/images/password.png" alt="" />
                  <el-input
                    v-if="ruleForm.type == '3'"
                    class="myClass"
                    placeholder="请输入公司名称"
                    v-model="ruleForm.name"
                  ></el-input>
                  <el-input
                    v-else
                    class="myClass"
                    placeholder="请输入姓名"
                    v-model="ruleForm.name"
                  ></el-input>
                </el-form-item>

                <el-form-item v-if="ruleForm.type == '3'" class="phone" prop="contact" style="width: 100%">
                  <img class="icons" src="../assets/images/password.png" alt="" />
                  <el-input
                    class="myClass"
                    placeholder="请输入企业联系人"
                    v-model="ruleForm.contact"
                  ></el-input>
                </el-form-item>

                <el-form-item class="phone" prop="gender" style="width: 100%">
                  <img class="icons" src="../assets/images/password.png" alt="" />
                  <div style="width: 50%;display: inline-block;">
                     <el-input
                      disabled
                      v-if="ruleForm.type == '3'"
                      class="myClass"
                      placeholder="请选择企业联系人性别"
                      v-model="ruleForm.gender"
                    ></el-input>
                    <el-input
                    v-else
                    disabled
                    class="myClass"
                    placeholder="请选择性别"
                    v-model="ruleForm.gender"
                  ></el-input>
                  </div>
                  <div style="display:inline">
                    <el-radio v-model="ruleForm.gender" label="男">男</el-radio>
                    <el-radio v-model="ruleForm.gender" label="女">女</el-radio>
                  </div>
                </el-form-item>


                <el-form-item class="phone" prop="industry" style="width: 100%">
                  <img class="icon" src="../assets/images/entser.png" alt="" />
                  <el-select
                    v-model="ruleForm.industry"
                    placeholder="请选择所属行业"
                    style="width: 100%"
                  >
                    <el-option label="水处理" value="4"></el-option>
                    <el-option label="大气处理" value="3"></el-option>
                    <el-option label="固废处理" value="5"></el-option>
                    <el-option label="环境修复" value="6"></el-option>
                    <el-option label="环境监测" value="7"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item v-if="ruleForm.type != '3'" class="phone" prop="company" style="width: 100%">
                  <img class="icons" src="../assets/images/password.png" alt="" />
                  <el-input
                    class="myClass"
                    placeholder="请输入就职单位"
                    v-model="ruleForm.company"
                  ></el-input>
                </el-form-item>

            

                <el-form-item class="phone" prop="password" style="width: 100%">
                  <img class="icons" src="../assets/images/password.png" alt="" />
                  <el-input
                    class="myClass"
                    type="password"
                    placeholder="请输入登录密码"
                    v-model="ruleForm.password"
                  ></el-input>
                </el-form-item>
                <el-form-item class="phone" prop="checkPass" style="width: 100%">
                  <img class="icons" src="../assets/images/password.png" alt="" />
                  <el-input
                    class="myClass"
                    type="password"
                    placeholder="请输入确认登录密码"
                    v-model="ruleForm.checkPass"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item class="code" prop="graphicCode" style="width: 100%">
                  <img class="icon_3" src="../assets/images/security.png" alt="" />
                  <div style="width: 50%">
                    <el-input
                      class="myClass"
                      placeholder="图形验证码"
                      v-model="ruleForm.graphicCode"
                      maxlength="5"
                    ></el-input>
                  </div>
                  <img
                    class="graphic_code"
                    :src="imgUrl"
                    alt=""
                    @click.prevent="getCaptcha()"
                  />
                  <!-- <p class="graphic_code">SDFGV</p> -->
                </el-form-item>
                <el-form-item class="phone" prop="integralCode" style="width: 100%">
                  <img class="icons" src="../assets/images/icons_4.png" alt="" />
                  <el-input
                    class="myClass"
                    type="password"
                    placeholder="邀请码（非必填）"
                    v-model="ruleForm.integralCode"
                  ></el-input>
                </el-form-item>
                <el-form-item class="shortCode" prop="smsCode" style="width: 100%">
                  <el-input
                    class="phoneCode"
                    placeholder="短信验证码"
                    v-model="ruleForm.smsCode"
                    maxlength="6"
                  ></el-input>
                  <button :disabled="disabled" class="shortBtn" @click.prevent="onCode()">
                    {{ getCodeText }}
                  </button>
                </el-form-item>
                <el-form-item prop="agree" class="fuck">
                  <el-checkbox v-model="ruleForm.agree" name="checked"></el-checkbox>
                  <div  class="agree_box">
                    我已阅读并接受《
                    <span class="agree_text" @click="settChange()">平台服务协议</span>
                    》《
                    <span class="agree_text" @click="settChanges()">用户入驻协议</span>
                    》和《
                    <span class="agree_text" @click="settChangeAar()">隐私政策</span>
                    》《
                    <span class="agree_text" @click="merChange()">会员服务协议</span>
                    》
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <div class="mt-10">
              <button class="register_btn background_1" @click.prevent="onLogin()">
                已有账号，去登录
              </button>
              <button
                class="register_btn background_2 ml-30"
                @click="submitForm('ruleForm')"
              >
                确定注册
              </button>
            </div>
          </div>
        </div>
        <div class="moblie_text">
          中国·山东环境领域“互联网+环保”务实发展为本的共享平台
        </div>
      </div>
    </div>
    <!--服务协议弹框-->
    <div class="sett_dialog" v-show="dialogTableVisible">
      <div class="sett_cox"></div>
      <div class="sett_dialog_box">
        <div class="sett_matter">
          <p class="sett_title">平台服务协议</p>
          <p class="sett_jitr">
            <span v-if="!isImg">{{ time }}s</span>
            <img
              v-show="isImg"
              src="../assets/images/sign.png"
              @click.prevent="onText()"
            />
          </p>
        </div>
        <div class="sett_desc" v-html="serviceAgreement.des"></div>
      </div>
    </div>

    <!--入驻协议弹框-->
    <div class="sett_dialog" v-show="dialogTableVisibles">
      <div class="sett_cox"></div>
      <div class="sett_dialog_box">
        <div class="sett_matter">
          <p class="sett_title">用户入驻协议</p>
          <p class="sett_jitr">
            <span v-if="!isImgs">{{ times }}s</span>
            <img
              v-show="isImgs"
              src="../assets/images/sign.png"
              @click.prevent="onTexts()"
            />
          </p>
        </div>
        <div class="sett_desc" v-html="registrationAgreement.des"></div>
      </div>
    </div>
    
    <!--隐私协议弹框-->
    <div class="sett_dialog" v-show="dialogTable">
      <div class="sett_cox"></div>
      <div class="sett_dialog_box">
        <div class="sett_matter">
          <p class="sett_title">隐私政策</p>
          <p class="sett_jitr">
            <span v-if="!isYmg">{{ timeter }}s</span>
            <img
              v-show="isYmg"
              src="../assets/images/sign.png"
              @click.prevent="onTextTer()"
            />
          </p>
        </div>
        <div class="sett_desc" v-html="pricacyAgreement.des"></div>
      </div>
    </div>
    
    <!--会员服务协议弹框-->
    <div class="sett_dialog" v-show="dialogMenber">
      <div class="sett_cox"></div>
      <div class="sett_dialog_box">
        <div class="sett_matter">
          <p class="sett_title">会员服务协议</p>
          <p class="sett_jitr">
            <span v-if="!merImg">{{ merTime }}s</span>
            <img
              v-show="merImg"
              src="../assets/images/sign.png"
              @click.prevent="onTextTer()"
            />
          </p>
        </div>
        <div class="sett_desc" v-html="memberAgreement.des"></div>
      </div>
    </div>

  </div>
</template>
<script>
import { getDict, agreement } from "@/api/coment";
import { register, checkMobile, getCode, getValidate } from "@/api/user";
import { formatTime, getUUID } from "../utils/index.js";
export default {
  data() {
    //验证手机号规则
    var checkMobile = (rule, value, callback) => {
      // 验证手机号的正则表达式
      // const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      const regMobile = /^1\d{10}$/;
      if (regMobile.test(value)) {
        return callback();
      }
      callback(new Error("请输入合法的手机号"));
    };
    //验证密码规则
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    //确认密码
    var validatePass2 = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入确认密码"));
      } else if (value != this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      getCodeText: "获取验证码",
      getCodeisWaiting: false,
      ruleForm: {
        mobile: "",
        type: "", //企业
        name: "", //姓名
        contact: "",  //企业联系人
        gender: "",   //性别
        company: "",  //就职单位
        industry: "",   //所属行业
        profession: "自由人", //所属行业
        password: "",
        graphicCode: "", //图形验证码
        smsCode: "", //短信验证码
        checkPass: "", //确认密码
        agree: "",
        integralCode: "", //邀请码
      },
      rules: {
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            validator: checkMobile,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        name: [{ required: true, message: "请输入名称", trigger: "change" }],
        contact: [{ required: true, message: "请输入企业联系人", trigger: "change" }],
        gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        company: [{ required: true, message: "请选择就职单位", trigger: "change" }],
        industry: [{ required: true, message: "请选择所属行业", trigger: "change" }],
        // profession: [
        //   { required: true, message: "请输入所属行业", trigger: "blur" },
        // ],
        password: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        graphicCode: [{ required: true, message: "请输入图形验证码", trigger: "blur" }],
        shortCode: [{ required: true, message: "请输入短信验证码", trigger: "blur" }],
        agree: [
          {
            required: true,
            message: "请接受智污邦平台服务协议和用户入驻协议",
            trigger: "change",
          },
        ],
      },
      imgUrl: "",
      uid: "",
      industry_type: "",
      categoryList: [], //行业
      disabled: false,
      dialogTableVisible: false,
      dialogTableVisibles: false,
      dialogTable:false,
      dialogMenber:false,
      serviceAgreement: "",
      registrationAgreement: "",
      pricacyAgreement:"",
      memberAgreement:'',
      setTetx: "",
      isImg: false,
      isImgs: false,
      isYmg:false,
      merImg:false,
      time: 10,
      times: 10,
      timeter:10,
      merTime:10
    };
  },
  created() {
    this.getCaptcha();
    this.getCailter();
    this.getAgreement();
  },
  methods: {
    setTimer() {
      let holdTime = 60;
      this.getCodeText = "重新获取(60)";
      this.Timer = setInterval(() => {
        if (holdTime <= 0) {
          this.getCodeisWaiting = false;
          this.getCodeText = "获取验证码";
          holdTime = 60;
          clearInterval(this.Timer);
          return;
        }
        this.getCodeText = "重新获取(" + holdTime + ")";
        holdTime--;
      }, 1000);
    },
    //登录
    onLogin() {
      this.$router.push("/login");
    },
    //帮助中心
    onSet() {
      this.$router.push("/help_center");
    },

    //首页
    onTout() {
      this.$router.push("/");
    },
    //检查手机是否被注册
    onInputBlur() {
      if (this.ruleForm.mobile != "") {
        let data = {
          mobile: this.ruleForm.mobile,
        };
        checkMobile(data)
          .then((res) => {})
          .catch((err) => {});
      } else {
        return false;
      }
    },
    //获取图形验证码
    getCaptcha() {
      this.uid = getUUID();
      this.imgUrl = `/api/zwb/app/captcha.jpg?uuid=${this.uid}`;
    },
    //校验图形验证码
    onblur() {
      if (!this.ruleForm.graphicCode) {
        this.$message({
          message: "请输入图形验证码",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      let params = {
        uuid: this.uid,
        imgCode: this.ruleForm.graphicCode,
      };
      getValidate(params)
        .then((res) => {
          if (res.code == 0) {
            this.onCode();
          }
        })
        .catch((err) => {});
    },
    //发送验证码
    onCode() {
      if (!this.ruleForm.mobile) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      if (!this.ruleForm.graphicCode) {
        this.$message({
          message: "请输入图形验证码",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      if (this.getCodeisWaiting) {
        return false;
      }
      let params = {
        mobile: this.ruleForm.mobile,
        uuid: this.uid,
        imgCode: this.ruleForm.graphicCode,
      };
      this.setTimer();
      this.getCodeisWaiting = true;
      getCode(params)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "验证码发送成功",
              type: "success",
              duration: 1000,
            });
          }
        })
        .catch((err) => {});
    },
    //注册
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          register(this.ruleForm)
            .then((res) => {
              if (res.code == 0) {
                this.$message({
                  message: "注册成功,积分+5，快去登录吧",
                  type: "success",
                  duration: 1000,
                  onClose: (res) => {
                    this.$router.push({
                      path: "/login",
                    });
                  },
                });
              }
            })
            .catch((err) => {});
        } else {
          return false;
        }
      });
    },
    //获取分类
    getCailter() {
      let params = {
        code: this.industry_type,
      };
      getDict(params)
        .then((res) => {
          if (res.code == 0) {
            this.categoryList = res.data[0].children;
            localStorage.setItem("categoryList", JSON.stringify(res.data));
          }
        })
        .catch((err) => {});
    },
    //查询入驻协议
    getAgreement() {
      agreement()
        .then((res) => {
          this.serviceAgreement = res.page.filter(
            (item) => item.name == "平台服务协议"
          )[0];
          this.registrationAgreement = res.page.filter(
            (item) => item.name == "用户入驻协议"
          )[0];
          this.pricacyAgreement = res.page.filter(
            (item) => item.name == "隐私政策"
          )[0];
          this.memberAgreement = res.page.filter(
            (item) => item.name == "会员服务协议"
          )[0];
        })
        .catch((err) => {});
    },
    //用户入驻协议
    settChange() {
      this.dialogTableVisible = true;
      this.timer = setInterval(() => {
        this.time--;
        if (this.time == 0) {
          clearInterval(this.timer);
          this.isImg = true;
        }
      }, 1000);
    },
    onText() {
      this.dialogTableVisible = false;
    },
    settChanges() {
      this.dialogTableVisibles = true;
      this.timers = setInterval(() => {
        this.times--;
        if (this.times == 0) {
          clearInterval(this.timers);
          this.isImgs = true;
        }
      }, 1000);
    },
    settChangeAar(){
      this.dialogTable = true;
      this.timerTer = setInterval(() => {
        this.timeter--;
        if (this.timeter == 0) {
          clearInterval(this.timerTer);
          this.isYmg = true;
        }
      }, 1000);
    },
    merChange(){
      this.dialogMenber = true;
       this.timerTers = setInterval(() => {
        this.merTime--;
        if (this.merTime == 0) {
          clearInterval(this.timerTers);
          this.merImg = true;
        }
      }, 1000);
    },
    onTexts() {
      this.dialogTableVisibles = false;
    },
    onTextTer(){
      this.dialogTable = false;
      this.dialogMenber = false;
    }
  },
};
</script>
<style scoped>
.login_bg {
  background: url("../assets/images/login.jpg") no-repeat center/cover;
  min-height: 100vh;
}
.fcl {
  display: flex;
  justify-content: left;
}
.mt-10 {
  margin-top: 10px;
}
.mt-20 {
  margin-top: 20px;
}
.ml-30 {
  margin-left: 30px;
}
.underline {
  padding-bottom: 5px;
  text-decoration: underline;
}
.info_form >>> .el-select .el-input__inner {
  color: #333333;
}
.info_form >>> .el-input--suffix .el-input__inner {
  padding-left: 50px;
  height: 50px;
  font-size: 12px;
  background: #ffffff;
  color: #999999;
}
.info_form >>> .el-select .el-input__inner:focus {
  border-color: #eeeeee;
}
.info_form >>> .el-select .el-input.is-focus .el-input__inner {
  border: 1px solid #eeeeee;
}
.info_form >>> .el-checkbox__inner {
  border-radius: 50%;
  border: 1px solid #50b035;
}
.info_form >>> .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #50b035;
}

.info_form >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #50b035;
  border-color: #50b035;
  border-radius: 50%;
}
.info_form >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #50b035;
}
.info_form >>> .el-checkbox__inner:hover {
  background-color: #50b035;
}
.info_form >>> .el-button {
  border: none;
}
.info_form >>> .el-form-item__content {
  margin-left: 0px !important;
}

.mobile_top {
  padding: 19px 22px;
}
.mobile_top span {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.mobile_top span:hover {
  cursor: pointer;
}
.mobile_middle {
  display: flex;
  /* justify-content: center; */
  align-items: center;
  flex-direction: column;
}
.moblie_conent {
  /* width: 536px; */
  width: 568px;
  background: rgba(255, 255, 255, 0.8);
  margin-top: 60px;
  padding: 35px 0px 0px 0px;
}
.moblie_bater {
  margin: 32px 30px;
}
.moblie_conent h4 {
  font-size: 22px;
  font-family: PingFangSC;
  font-weight: bold;
  color: #333333;
}
.moblie_logo {
  display: flex;
  justify-content: center;
}
.moblie_logo img {
  width: 189px;
  height: 59px;
  cursor: pointer;
}
.phone {
  position: relative;
}
.icon {
  width: 20px;
  height: 22px;
  position: absolute;
  top: 12px;
  left: 10px;
  z-index: 10;
}
.icons {
  width: 26px;
  height: 24px;
  position: absolute;
  top: 12px;
  left: 10px;
  z-index: 10;
}
.icon_3 {
  width: 22px;
  height: 21px;
  position: absolute;
  top: 12px;
  left: 10px;
  z-index: 10;
}
.code {
  position: relative;
}
.graphic_code {
  position: absolute;
  right: 0;
  top: 0;
  width: 125px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  background: #cdcdcd;
  color: #323232;
}
.shortCode {
  position: relative;
}
.shortBtn {
  position: absolute;
  top: 0;
  right: 0;
  width: 125px;
  height: 50px;
  background: #e5e5e5;
}

.not span {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.background_1 {
  background: linear-gradient(104deg, #ff8102, #ffd101);
}
.background_2 {
  background: linear-gradient(104deg, #d1e80d, #69cc1e);
}
.register_btn {
  width: 45%;
  height: 50px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.moblie_text {
  /* width: 441px; */
  text-align: center;
  margin-top: 15px;
  font-size: 18px;
  font-family: PingFangSC;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
  padding-bottom: 60px;
}
/deep/.myClass input.el-input__inner {
  padding-left: 50px;
  font-size: 12px;
  height: 50px;
  background: #ffffff !important;
  border: 1px solid #eeeeee;
}

/* /deep/.myClassGender input.el-input__inner {
  padding-left: 50px;
  font-size: 12px;
  height: 50px;
  background: #ffffff !important;
  border: 1px solid #eeeeee;
  display:inline
} */


/deep/.phoneCode input.el-input__inner {
  padding-left: 12px;
  font-size: 12px;
  height: 50px;
  background: #ffffff !important;
  border: 1px solid #eeeeee;
}

.sett_dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  margin: 0;
  z-index: 100;
}
.sett_dialog_box {
  width: 500px;
  height: 600px;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 3px;
  transform: translate(-50%, -50%);
  background: #ffffff;
  overflow: auto;
}
.sett_cox {
  position: fixed;
  left: 0;
  /* opacity: 0.3; */
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  /* z-index:2003 !important; */
}
.sett_matter {
  position: relative;
  height: 50px;
}
.sett_title {
  font-size: 22px;
  color: #666666;
  height: 30px;
  line-height: 48px;
  text-align: center;
}
.sett_jitr {
  position: absolute;
  right: 20px;
  top: 10px;
}
.sett_jitr img {
  width: 20px;
  height: 20px;
}
/**协议弹框 */
.sett_dialog >>> .el-dialog {
  width: 500px;
  height: 600px;
}
.sett_dialog >>> .el-dialog__header {
  text-align: center;
}
.sett_dialog >>> .el-dialog__title {
  font-size: 24px;
}
.sett_desc {
  padding: 30px;
  font-size: 14px;
  line-height: 24px;
  color: #666666;
}
/deep/ .fuck .el-form-item__content {
  display: flex;
  align-items: center;
}
.agree_box{
  font-size: 12px;
  margin-left: 5px;
}
.agree_box span:last-child{
  margin-top: -20px;
}

.agree_text {
  cursor: pointer;
  font-size: 12px;
  color: #69cc1e;
}
.agree_text:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/view/register.vue